import { Component, Inject, LOCALE_ID } from '@angular/core';
import { ConfigService } from '../@vex/services/config.service';
import { Settings } from 'luxon';
import { SplashScreenService } from '../@vex/services/splash-screen.service';
import { Style, StyleService } from '../@vex/services/style.service';
import { ConfigName } from '../@vex/interfaces/config-name.model';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'aum-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private configService: ConfigService,
    private styleService: StyleService,
    @Inject(LOCALE_ID) private localeId: string,
    private splashScreenService: SplashScreenService,
    private translate: TranslateService
  ) {
    Settings.defaultLocale = this.localeId;

    this.styleService.setStyle(Style.dark);
    this.configService.updateConfig({
      id: ConfigName.ikaros,
      name: 'Ikaros',
      imgSrc: '//vex-landing.visurel.com/assets/img/layouts/ikaros.png',
      layout: 'vertical',
      boxed: true,
      toolbar: {
        fixed: false
      },
      navbar: {
        position: 'in-toolbar'
      },
      footer: {
        fixed: true,
        visible: true
      }
    });

    this.translate.addLangs(['en', 'de', 'it', 'sp']);
    const currentLang = localStorage.getItem('language')
      ? localStorage.getItem('language')
      : 'en';
    this.translate.setDefaultLang(currentLang);
  }
}
